import { Alert, TableBody, TableCell } from "@mui/material";

import { StyledTableRow } from "./styled-components";

const NoInformation = () => (
  <TableBody>
    <StyledTableRow>
      <TableCell>
        <Alert severity="error">No Information Available</Alert>
      </TableCell>
    </StyledTableRow>
  </TableBody>
);

export default NoInformation;
